<template>
  <QuestionBody :qsNumber="qsNumber" :nextPage="nextPage" :navigateType="navigateType" :content="content" />
</template>

<script>
import QuestionBody from '@/layout/QuestionBody.vue'
export default {
  name: "Qs2-04",
  components: {
    QuestionBody
  },
  data() {
    return {
      qsNumber: 24,
      nextPage: '/questionnaire/section2/5',
      navigateType: 'CLICK_ANY_BTN',
      content: {
        componentsType: {
          pc: 'longBtn',
          mobile: 'normalBtn'
        },
        titleIcon: require('@/assets/icon/questionIcon/25-Immunity.png'),
        mainTitle: 'Do you often have to travel long distances or on business?',
        btn: [
          [
            {
              text: 'Yes',
            }
          ],[
            {
              text: 'Occasionally',
            }
          ],[
            {
              text: 'No',
            }
          ]
        ]
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
</style>
